import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState ={
    isLoading : false,
    dashboarddata: [],
    totalDashboardData: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    iscloading:false,
    cstatus:"",
    cmessage:"",
    cdetails:{},
    ismloading:false,
    mstatus:"",
    mmessage:"",
    commissions: [],
    dstatus:"",
    dmessage:"",
    
};


const dashboarddataListSlice = createSlice({
    name: "dashboarddataList",
    initialState,
    reducers:{
        getDashboardDataPending: (state) => {
            state.isLoading = true;
        },
        getDashboardDataSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dashboarddata = payload;
            state.cdetails = payload;
           // state.user="slice userData";
            state.error = '';
            console.log("lamha",payload)
        },
        getDashboardDataFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
       
        reset: () => initialState
    },
});

const { reducer, actions } = dashboarddataListSlice;

export const { getDashboardDataPending, getDashboardDataSuccess, getDashboardDataFail} = actions;

export default reducer;
